import { createSlice } from "@reduxjs/toolkit";
import jwtDecode from "jwt-decode";

const userSlice = createSlice({
  name: "user",
  initialState: {
    userInfo: null,
    currentUser: false,
    token: localStorage.getItem("token"),
    id: localStorage.getItem("userId"),
    isFetching: false,
    error: false,
    msgUserErr: "",
  },
  reducers: {
    loginStart: (state) => {
      state.isFetching = true;
    },
    loginSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
      state.userInfo = action.payload;
      state.currentUser = true;
      state.token = localStorage.getItem("token");
      state.id = localStorage.getItem("userId");

      // console.log(state.currentUser.token);

      localStorage.setItem("userId", state.userInfo.userId);
      localStorage.setItem("token", state.userInfo.token);
    },
    loginFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;

      state.msgUserErr = action.payload;
    },

    logout: (state, action) => {
      state.userInfo = action.payload;
      state.currentUser = false;
      state.token = "";
      state.id = "";

      localStorage.removeItem("token");
      localStorage.removeItem("userId");
    },

    loadUser: (state, action) => {
      const token = state.token;

      if (token) {
        const user = jwtDecode(token);
        console.log(user);
        console.log(state);
        return {
          ...state,
          userInfo: user,
          token,
          id: user.userId,
          currentUser: true,
        };
      } else {
        // console.log(state);
        return { ...state, currentUser: false };
      }
    },

    registerStart: (state, action) => {
      state.isFetching = true;
    },

    registerSuccess: (state, action) => {
      state.isFetching = false;
      state.error = false;
      state.userInfo = action.payload;
      // state.currentUser = true;
      // state.id = localStorage.getItem("userId");

      // localStorage.setItem("userId", state.userInfo.userId);
    },
    registerFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;

      state.msgUserErr = action.payload;
    },
  },
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  loadUser,
  registerStart,
  registerSuccess,
  registerFailure,
} = userSlice.actions;
export default userSlice.reducer;
